// extracted by mini-css-extract-plugin
export default {"flexCard":"Admin_flexCard__TBsZ0","customChip":"Admin_customChip__SO63S"};